module.exports = __webpack_public_path__ + "img/technological-stack.247aff98.png";